import { isEqual } from 'lodash'
import qs from 'query-string'

export default {
  methods: {
    search() {
      const { unit, startTerm, endTerm, timeZone, statusType, type } = this.conditions

      const query = { unit, startTerm, endTerm }
      if (this.useTimeZone) query.timeZone = timeZone
      if (this.useStatusType) query.statusType = statusType
      if (this.useType) query.type = type

      Object.entries(query).map(([key, value]) => (query[key] = `${value}`))
      if (isEqual(this.$route.query, query)) {
        this.refetch()
      } else {
        this.$router.push(`?${qs.stringify(query)}`)
      }
    },
  },
}
